import { render, staticRenderFns } from "./GroupAddGroup.vue?vue&type=template&id=1b20d9bf&scoped=true&"
import script from "./GroupAddGroup.vue?vue&type=script&lang=ts&"
export * from "./GroupAddGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b20d9bf",
  null
  
)

export default component.exports